import {Box, Divider, Stack, Typography} from "@mui/joy";
import {useTranslation} from "react-i18next";

// Footer minimale — stessa vibe del fondo di ProfileScreen su Flutter
// (logo + nome app + "Developed by Daniele Di Gregorio" in piccolo).
export function Footer() {
    const {t} = useTranslation();
    const year = new Date().getFullYear();

    return (
        <Box component="footer" sx={{mt: "auto", pt: 6, pb: 4}}>
            <Divider sx={{mb: 3}} />
            <Stack
                direction={{xs: "column", sm: "row"}}
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                sx={{maxWidth: 1000, mx: "auto", px: 3}}
            >
                <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" justifyContent="center">
                    <Typography
                        level="body-sm"
                        component="a"
                        href="https://cinefx.danieledigregorio.it/privacy"
                        target="_blank"
                        rel="noreferrer"
                        sx={{color: "neutral.400", textDecoration: "none", "&:hover": {color: "neutral.200"}}}
                    >
                        {t("privacypolicy")}
                    </Typography>
                    <Typography
                        level="body-sm"
                        component="a"
                        href="https://cinefx.danieledigregorio.it/terms"
                        target="_blank"
                        rel="noreferrer"
                        sx={{color: "neutral.400", textDecoration: "none", "&:hover": {color: "neutral.200"}}}
                    >
                        {t("termsandconditions")}
                    </Typography>
                    <Typography
                        level="body-sm"
                        component="a"
                        href="https://cinefx.danieledigregorio.it"
                        target="_blank"
                        rel="noreferrer"
                        sx={{color: "neutral.400", textDecoration: "none", "&:hover": {color: "neutral.200"}}}
                    >
                        cinefx.danieledigregorio.it
                    </Typography>
                </Stack>
                <Typography level="body-xs" sx={{color: "neutral.500", textAlign: "center"}}>
                    © {year} CineFX — {t("developedby")} Daniele Di Gregorio
                </Typography>
            </Stack>
        </Box>
    );
}
